import { useEffect, useState } from "react";
import { api } from "../api/client";
import { Modal, FormGroup, Spinner } from "../components/UI";

export default function Gremien() {
  const [gremien, setGremien] = useState([]);
  const [mitglieder, setMitglieder] = useState([]);
  const [kcGroups, setKcGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [activeTab, setActiveTab] = useState("allgemein");
  const [abstimmungsTypen, setAbstimmungsTypen] = useState([]);
  const [loadingTypen, setLoadingTypen] = useState(false);
  const [editG, setEditG] = useState(null);
  const [form, setForm] = useState({ name: "", beschreibung: "", kuerzel: "", standard_ort: "", keycloak_group_id: "", keycloak_group_name: "", keycloak_admin_group_id: "", keycloak_admin_group_name: "", keycloak_schriftfuehrer_group_id: "", keycloak_schriftfuehrer_group_name: "", keycloak_nicht_stimmberechtigt_group_id: "", keycloak_nicht_stimmberechtigt_group_name: "", verlauf_fuer_mitglieder: false, beschlussfaehig_quote_prozent: 50, beschlussfaehig_rundung: "auf" });

  const load = () => Promise.all([api.getGremien(), api.getMitglieder()])
    .then(([g, m]) => { setGremien(g); setMitglieder(m); })
    .finally(() => setLoading(false));

  useEffect(() => {
    load();
    api.getKeycloakGroups().then(setKcGroups).catch(() => setKcGroups([]));
  }, []);

  const save = async () => {
    if (editG) await api.updateGremium(editG.id, form);
    else await api.createGremium(form);
    setShowForm(false); load();
  };

  const openEdit = (g) => {
    setForm({ name: g.name, beschreibung: g.beschreibung || "", kuerzel: g.kuerzel || "", standard_ort: g.standard_ort || "", keycloak_group_id: g.keycloak_group_id || "", keycloak_group_name: g.keycloak_group_name || "", keycloak_admin_group_id: g.keycloak_admin_group_id || "", keycloak_admin_group_name: g.keycloak_admin_group_name || "", keycloak_schriftfuehrer_group_id: g.keycloak_schriftfuehrer_group_id || "", keycloak_schriftfuehrer_group_name: g.keycloak_schriftfuehrer_group_name || "", keycloak_nicht_stimmberechtigt_group_id: g.keycloak_nicht_stimmberechtigt_group_id || "", keycloak_nicht_stimmberechtigt_group_name: g.keycloak_nicht_stimmberechtigt_group_name || "", verlauf_fuer_mitglieder: g.verlauf_fuer_mitglieder || false });
    setEditG(g); setShowForm(true);
  };

  const openNew = () => {
    setForm({ name: "", beschreibung: "", kuerzel: "", standard_ort: "", keycloak_group_id: "", keycloak_group_name: "", keycloak_admin_group_id: "", keycloak_admin_group_name: "", keycloak_schriftfuehrer_group_id: "", keycloak_schriftfuehrer_group_name: "", keycloak_nicht_stimmberechtigt_group_id: "", keycloak_nicht_stimmberechtigt_group_name: "", verlauf_fuer_mitglieder: false });
    setEditG(null); setShowForm(true);
  };

  const onGroupSelect = (e) => {
    const sel = kcGroups.find(g => g.id === e.target.value);
    setForm(f => ({ ...f, keycloak_group_id: sel?.id || "", keycloak_group_name: sel?.name || "", name: f.name || sel?.name || "" }));
  };
  // Phase B: Abstimmungs-Typen für gewähltes Gremium nachladen
  const loadAbstimmungsTypen = (gid) => {
    if (!gid) { setAbstimmungsTypen([]); return; }
    setLoadingTypen(true);
    api.getGremiumAbstimmungsTypen(gid)
      .then(t => setAbstimmungsTypen(t || []))
      .catch(() => setAbstimmungsTypen([]))
      .finally(() => setLoadingTypen(false));
  };
  // Phase B: wenn Modal mit existing Gremium öffnet, Typen laden
  useEffect(() => { if (editG?.id) loadAbstimmungsTypen(editG.id); else setAbstimmungsTypen([]); }, [editG?.id]);



  if (loading) return <div style={{padding:40,color:"#999"}}>Lädt…</div>;

  return (
    <div>
      <div className="page-header">
        <div><div className="breadcrumb">Verwaltung</div><h2>Gremien</h2></div>
        <div className="page-actions">
          <button className="btn btn-primary" onClick={openNew}>+ Gremium anlegen</button>
        </div>
      </div>

      <div className="content">
        <div className="grid-2">
          <div className="card">
            <div className="card-header"><h3>Gremien ({gremien.length})</h3></div>
            <div style={{ padding: 0 }}>
              {gremien.length === 0 ? (
                <div className="empty-state"><div className="empty-icon">👥</div><p>Keine Gremien vorhanden</p></div>
              ) : (
                <table className="table">
                  <tbody>
                    {gremien.map(g => (
                      <tr key={g.id} style={{ cursor: "pointer" }} onClick={() => setSelected(g)}>
                        <td>
                          <div style={{ fontWeight: selected?.id === g.id ? 600 : 400, color: selected?.id === g.id ? "var(--red)" : "inherit" }}>{g.name}</div>
                          {g.keycloak_group_name
                            ? <div style={{ fontSize: 11, color: "#2e7d32" }}>🔗 {g.keycloak_group_name}</div>
                            : <div style={{ fontSize: 11, color: "#e65100" }}>⚠ Keine Keycloak-Gruppe</div>}
                        </td>
                        <td><button className="btn btn-ghost btn-icon btn-sm" title="Bearbeiten" aria-label="Bearbeiten" onClick={e => { e.stopPropagation(); openEdit(g); }}>✎</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {selected && (
            <div className="card">
              <div className="card-header"><h3>{selected.name}</h3></div>
              <div className="card-body">
                {selected.keycloak_group_name ? (
                  <div style={{ padding: "8px 12px", background: "#e8f5e9", borderRadius: 4, fontSize: 13, marginBottom: 16 }}>
                    🔗 Keycloak-Gruppe: <strong>{selected.keycloak_group_name}</strong><br/>
                    <span style={{ fontSize: 11, color: "#555" }}>Mitglieder werden live aus FreeIPA über Keycloak geladen.</span>
                  </div>
                ) : (
                  <div style={{ padding: "8px 12px", background: "#fff3e0", borderRadius: 4, fontSize: 13 }}>
                    ⚠ Keine Keycloak-Gruppe zugeordnet.<br/>
                    <button className="btn btn-ghost btn-sm" style={{ marginTop: 6 }} onClick={() => openEdit(selected)}>Jetzt zuordnen</button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {showForm && (
        <Modal title={editG ? "Gremium bearbeiten" : "Neues Gremium"} size="large" onClose={() => setShowForm(false)}
          footer={<>
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Abbrechen</button>
            <button className="btn btn-primary" onClick={save}>Speichern</button>
          </>}>

          {/* Phase B: Tab-Navigation */}
          {editG?.id && (
            <div style={{ display: "flex", gap: 12, borderBottom: "1px solid #e5e5e5", marginBottom: 16 }}>
              <button type="button"
                onClick={() => setActiveTab("allgemein")}
                style={{
                  background: "none", border: "none", padding: "8px 4px",
                  borderBottom: activeTab === "allgemein" ? "2px solid var(--red, #c00)" : "2px solid transparent",
                  fontWeight: activeTab === "allgemein" ? 600 : 400,
                  cursor: "pointer", color: activeTab === "allgemein" ? "var(--red, #c00)" : "#666",
                }}>Allgemein</button>
              <button type="button"
                onClick={() => setActiveTab("abstimmungs-typen")}
                style={{
                  background: "none", border: "none", padding: "8px 4px",
                  borderBottom: activeTab === "abstimmungs-typen" ? "2px solid var(--red, #c00)" : "2px solid transparent",
                  fontWeight: activeTab === "abstimmungs-typen" ? 600 : 400,
                  cursor: "pointer", color: activeTab === "abstimmungs-typen" ? "var(--red, #c00)" : "#666",
                }}>Abstimmungs-Typen</button>
            </div>
          )}

          <div data-tab="allgemein" style={{ display: (!editG?.id || activeTab === "allgemein") ? "block" : "none" }}>
          <FormGroup label="Keycloak-Gruppe (aus FreeIPA)">
            {kcGroups.length === 0
              ? <div style={{ fontSize: 12, color: "#e65100" }}>Keine Keycloak-Gruppen gefunden — Service Account konfiguriert?</div>
              : <select className="form-control" value={form.keycloak_group_id} onChange={onGroupSelect}>
                  <option value="">— Keine Gruppe —</option>
                  {kcGroups.map(g => <option key={g.id} value={g.id}>{g.path}</option>)}
                </select>}
          </FormGroup>

          <FormGroup label="Keycloak-Gruppe Vorsitz (kann TOPs/Sitzung verwalten)">
            {kcGroups.length === 0
              ? <div style={{ fontSize: 12, color: "#999" }}>—</div>
              : <select className="form-control" value={form.keycloak_admin_group_id}
                  onChange={e => {
                    const sel = kcGroups.find(g => g.id === e.target.value);
                    setForm(f => ({ ...f, keycloak_admin_group_id: sel?.id || "", keycloak_admin_group_name: sel?.name || "" }));
                  }}>
                  <option value="">— Keine Gruppe —</option>
                  {kcGroups.map(g => <option key={g.id} value={g.id}>{g.path}</option>)}
                </select>}
          </FormGroup>

          <FormGroup label="Keycloak-Gruppe Schriftführer (kann Protokoll & Zusammenfassung schreiben)">
            {kcGroups.length === 0
              ? <div style={{ fontSize: 12, color: "#999" }}>—</div>
              : <select className="form-control" value={form.keycloak_schriftfuehrer_group_id}
                  onChange={e => {
                    const sel = kcGroups.find(g => g.id === e.target.value);
                    setForm(f => ({ ...f, keycloak_schriftfuehrer_group_id: sel?.id || "", keycloak_schriftfuehrer_group_name: sel?.name || "" }));
                  }}>
                  <option value="">— Keine Gruppe —</option>
                  {kcGroups.map(g => <option key={g.id} value={g.id}>{g.path}</option>)}
                </select>}
          </FormGroup>

          <FormGroup label="Verlauf-Tab">
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: "pointer" }}>
              <input type="checkbox"
                checked={!!form.verlauf_fuer_mitglieder}
                onChange={e => setForm(f => ({ ...f, verlauf_fuer_mitglieder: e.target.checked }))} />
              Verlauf-Tab für alle Mitglieder sichtbar
            </label>
            <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
              Wenn nicht aktiv: Nur Vorsitz/Schriftführer/Admin sehen den Verlauf-Tab.
            </div>
          </FormGroup>
          <div className="form-row">
          <FormGroup label="Name *">
            <input className="form-control" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
          </FormGroup>
          <FormGroup label="Kürzel">
            <input className="form-control" value={form.kuerzel} placeholder="z. B. GW" maxLength={10}
              onChange={e => setForm(f => ({ ...f, kuerzel: e.target.value.toUpperCase() }))} />
          </FormGroup>
          </div>
          <FormGroup label="Standard-Sitzungsort">
            <input className="form-control" value={form.standard_ort} placeholder="z. B. Gerätehaus Hauptwache"
              onChange={e => setForm(f => ({ ...f, standard_ort: e.target.value }))} />
          </FormGroup>
          <FormGroup label="Beschreibung">
            <textarea className="form-control" rows={3} value={form.beschreibung} onChange={e => setForm(f => ({ ...f, beschreibung: e.target.value }))} />
          </FormGroup>
        
          </div>

          {/* Phase B: Tab Abstimmungs-Typen */}
          {editG?.id && (
            <div data-tab="abstimmungs-typen" style={{ display: activeTab === "abstimmungs-typen" ? "block" : "none" }}>
              <p style={{ fontSize: 13, color: "#666", marginBottom: 12 }}>
                Pro Abstimmungs-Typ: Beschlussfähigkeit (Anwesenheits-Quorum) UND Mehrheit. Werte überschreiben die systemweiten Defaults für dieses Gremium.
              </p>
              {loadingTypen ? (
                <div>Lädt…</div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                  <thead>
                    <tr style={{ borderBottom: "2px solid #e5e5e5", background: "#fafafa" }}>
                      <th rowSpan={2} style={{ textAlign: "left", padding: "8px 6px", verticalAlign: "bottom" }}>Typ</th>
                      <th colSpan={2} style={{ padding: "6px 4px", borderBottom: "1px solid #eee", color: "#666" }}>
                        Beschlussfähigkeit
                      </th>
                      <th colSpan={3} style={{ padding: "6px 4px", borderBottom: "1px solid #eee", color: "#666" }}>
                        Mehrheit
                      </th>
                      <th rowSpan={2} style={{ padding: "8px 4px", verticalAlign: "bottom" }}>Aktiv</th>
                      <th rowSpan={2} style={{ padding: "8px 4px", verticalAlign: "bottom" }}></th>
                    </tr>
                    <tr style={{ borderBottom: "2px solid #e5e5e5", background: "#fafafa" }}>
                      <th style={{ padding: "4px", fontSize: 11, fontWeight: 500 }}>Anwes. %</th>
                      <th style={{ padding: "4px", fontSize: 11, fontWeight: 500 }}>Rund.</th>
                      <th style={{ padding: "4px", fontSize: 11, fontWeight: 500 }}>Quote %</th>
                      <th style={{ padding: "4px", fontSize: 11, fontWeight: 500 }}>Basis</th>
                      <th style={{ padding: "4px", fontSize: 11, fontWeight: 500 }}>Rund.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {abstimmungsTypen.map(t => (
                      <tr key={t.abstimmungs_typ_id}
                          style={{ borderBottom: "1px solid #f0f0f0",
                                   background: t.ist_override ? "#fffbe6" : "transparent" }}>
                        <td style={{ padding: "6px" }}>
                          <div style={{ fontWeight: 500 }}>
                            {t.bezeichnung}
                            {t.ist_override && <span style={{ fontSize: 10, marginLeft: 6, color: "#b58900" }}>● Override</span>}
                          </div>
                          <div style={{ fontSize: 10, color: "#888" }}>{t.beschreibung}</div>
                        </td>
                        {/* Beschlussfähigkeit */}
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          <input type="number" min="1" max="100" value={t.anwesenheits_quote_prozent}
                            style={{ width: 56, padding: 3, fontSize: 12 }}
                            onChange={e => {
                              const v = parseInt(e.target.value) || 1;
                              setAbstimmungsTypen(arr => arr.map(x => x.abstimmungs_typ_id === t.abstimmungs_typ_id ? {...x, anwesenheits_quote_prozent: v} : x));
                            }} />
                        </td>
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          <select value={t.anwesenheits_rundung}
                            style={{ padding: 3, fontSize: 11 }}
                            onChange={e => setAbstimmungsTypen(arr => arr.map(x => x.abstimmungs_typ_id === t.abstimmungs_typ_id ? {...x, anwesenheits_rundung: e.target.value} : x))}>
                            <option value="auf">auf</option>
                            <option value="ab">ab</option>
                          </select>
                        </td>
                        {/* Mehrheit */}
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          <input type="number" min="1" max="100" value={t.mehrheits_quote_prozent}
                            style={{ width: 56, padding: 3, fontSize: 12 }}
                            onChange={e => {
                              const v = parseInt(e.target.value) || 1;
                              setAbstimmungsTypen(arr => arr.map(x => x.abstimmungs_typ_id === t.abstimmungs_typ_id ? {...x, mehrheits_quote_prozent: v} : x));
                            }} />
                        </td>
                        <td style={{ padding: "4px" }}>
                          <select value={t.mehrheits_basis}
                            style={{ padding: 3, fontSize: 11 }}
                            onChange={e => setAbstimmungsTypen(arr => arr.map(x => x.abstimmungs_typ_id === t.abstimmungs_typ_id ? {...x, mehrheits_basis: e.target.value} : x))}>
                            <option value="ja_nein_stimmen">Ja/Nein</option>
                            <option value="abgegebene_stimmen">Abgegebene</option>
                            <option value="anwesende_stimmberechtigte">Anwes. stb.</option>
                          </select>
                        </td>
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          <select value={t.mehrheits_rundung}
                            style={{ padding: 3, fontSize: 11 }}
                            onChange={e => setAbstimmungsTypen(arr => arr.map(x => x.abstimmungs_typ_id === t.abstimmungs_typ_id ? {...x, mehrheits_rundung: e.target.value} : x))}>
                            <option value="auf">auf</option>
                            <option value="ab">ab</option>
                          </select>
                        </td>
                        {/* Aktiv */}
                        <td style={{ padding: "4px", textAlign: "center" }}>
                          <input type="checkbox" checked={t.aktiv}
                            onChange={e => setAbstimmungsTypen(arr => arr.map(x => x.abstimmungs_typ_id === t.abstimmungs_typ_id ? {...x, aktiv: e.target.checked} : x))} />
                        </td>
                        {/* Aktionen */}
                        <td style={{ padding: "4px", whiteSpace: "nowrap" }}>
                          <button type="button" className="btn btn-secondary"
                            style={{ fontSize: 11, padding: "3px 8px" }}
                            onClick={async () => {
                              try {
                                await api.patchGremiumAbstimmungsTyp(editG.id, t.abstimmungs_typ_id, {
                                  anwesenheits_quote_prozent: t.anwesenheits_quote_prozent,
                                  anwesenheits_rundung: t.anwesenheits_rundung,
                                  mehrheits_quote_prozent: t.mehrheits_quote_prozent,
                                  mehrheits_basis: t.mehrheits_basis,
                                  mehrheits_rundung: t.mehrheits_rundung,
                                  aktiv: t.aktiv,
                                });
                                loadAbstimmungsTypen(editG.id);
                              } catch (e) { alert("Speichern fehlgeschlagen: " + (e?.message || e)); }
                            }}>Speichern</button>
                          {t.ist_override && (
                            <button type="button" className="btn btn-ghost"
                              style={{ fontSize: 11, padding: "3px 6px", marginLeft: 4 }}
                              title="Override entfernen, Default wieder verwenden"
                              onClick={async () => {
                                if (!confirm("Override entfernen und Default-Werte wieder verwenden?")) return;
                                await api.resetGremiumAbstimmungsTyp(editG.id, t.abstimmungs_typ_id);
                                loadAbstimmungsTypen(editG.id);
                              }}>↺</button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <p style={{ fontSize: 12, color: "#888", marginTop: 12 }}>
                Hinweis: „↺" entfernt den Override und stellt den systemweiten Default wieder her.
              </p>
            </div>
          )}

        </Modal>
      )}
    </div>
  );
}
